import { PauseCircle, UserX } from 'lucide-react';

import type { ConversaDetalhe } from '@/api/secretario';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Spinner } from '@/components/ui/spinner';

interface NumeroDoContatoProps {
  dossie: ConversaDetalhe;
  ocupado: boolean;
  onDevolver: () => void;
  onIgnorar: () => void;
}

/**
 * O que o Secretário faz com este número daqui para a frente: atende (padrão),
 * está quieto até o fim do dia porque o advogado respondeu pelo celular, ou nunca
 * atende (lista do advogado).
 */
export function NumeroDoContato({ dossie, ocupado, onDevolver, onIgnorar }: NumeroDoContatoProps) {
  if (dossie.numero_ignorado) {
    return (
      <Card>
        <CardContent className="flex items-start gap-3 p-4 text-sm">
          <UserX className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" aria-hidden="true" />
          <p className="text-muted-foreground">
            O Secretário não atende este número. Para mudar, use a lista no passo Número da configuração.
          </p>
        </CardContent>
      </Card>
    );
  }

  if (dossie.secretario_pausado) {
    return (
      <Card>
        <CardContent className="space-y-3 p-4 text-sm">
          <div className="flex items-start gap-3">
            <PauseCircle className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" aria-hidden="true" />
            <p>
              Você respondeu a esta pessoa hoje pelo celular. O Secretário fica quieto com ela até o fim do dia.
            </p>
          </div>
          <Button type="button" variant="outline" size="sm" onClick={onDevolver} disabled={ocupado}>
            {ocupado && <Spinner size={16} className="mr-2 text-inherit" />}
            Devolver ao Secretário
          </Button>
        </CardContent>
      </Card>
    );
  }

  // O número ignorado vale para o Secretário inteiro: é de quem o gere.
  if (dossie.pode_gerir === false) return null;
  return (
    <div className="px-1">
      <Button
        type="button"
        variant="link"
        size="sm"
        className="h-auto min-h-11 px-0 text-muted-foreground sm:min-h-0"
        onClick={onIgnorar}
        disabled={ocupado}
      >
        O Secretário não deve atender este número
      </Button>
    </div>
  );
}
